import React from "react";
import Layout from "../components/App/Layout";
import SEO from "../components/App/SEO";

import Section from "../components/Salary/Section";
import Counter from "../components/Salary/Counter";
import ManualCalc from "../components/Salary/ManualCalc";
import ReservationBlock from "../components/Common/ReservationBlock";
import MoreProducts from "../components/Common/MoreProducts";
import Intelligence from "../components/Salary/Intelligence";
import Change from "../components/Salary/Change";
import Projects from "../components/Salary/Projects";
import Values from "../components/Salary/Values";

const Salary = () => {
  return (
    <Layout>
      <SEO
        title="大任HR软件-自动化薪酬计算系统助力工资统计与成本分析管理"
        ogTitle="专业人力资源信息化系统，助力薪酬数据统计与高效管理-成都市大任软件有限责任公司"
        keywords="薪酬计算系统，薪酬核算系统，薪酬管理系统，工资核算软件"
        description="薪酬计算系统是一款自动化处理员工薪资信息的工具，主要功能包括基本工资计算、加班费及奖金管理、福利与补贴计算、税收自动扣除等。它能够根据企业的薪酬政策和计算规则，自动整合员工工作时长、考勤记录等数据，进行准确高效的薪酬核算。此外，系统还支持生成薪酬报表，提供数据分析功能，帮助企业管理层制定合理的薪酬策略。"
      />

      <Section />
      <Counter />
      <ManualCalc />
      <Intelligence />
      <Change />
      <section className="history-area pt-70 pb-70 bg-light">
        <div className="container">
          <Projects />
        </div>
      </section>
      <Values />
      <MoreProducts omits="salary" />
      <ReservationBlock omits={["services", "scale"]} light />
    </Layout>
  );
};

export default Salary;
